"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRelaysCache = void 0;
const _1 = require(".");
const shared_1 = require("@snort/shared");
class UserRelaysCache extends shared_1.FeedCache {
    constructor() {
        super("UserRelays", _1.db.userRelays);
    }
    key(of) {
        return of.pubkey;
    }
    async preload(follows) {
        await super.preload();
        if (follows) {
            await this.buffer(follows);
        }
    }
    newest() {
        let ret = 0;
        this.cache.forEach(v => (ret = v.created_at > ret ? v.created_at : ret));
        return ret;
    }
    takeSnapshot() {
        return [...this.cache.values()];
    }
}
exports.UserRelaysCache = UserRelaysCache;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1yZWxheXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2FjaGUvdXNlci1yZWxheXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsd0JBQW9DO0FBQ3BDLDBDQUEwQztBQUUxQyxNQUFhLGVBQWdCLFNBQVEsa0JBQXNCO0lBQ3pEO1FBQ0UsS0FBSyxDQUFDLFlBQVksRUFBRSxLQUFFLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDckMsQ0FBQztJQUVELEdBQUcsQ0FBQyxFQUFlO1FBQ2pCLE9BQU8sRUFBRSxDQUFDLE1BQU0sQ0FBQztJQUNuQixDQUFDO0lBRVEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUF1QjtRQUM1QyxNQUFNLEtBQUssQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUN0QixJQUFJLE9BQU8sRUFBRTtZQUNYLE1BQU0sSUFBSSxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQztTQUM1QjtJQUNILENBQUM7SUFFRCxNQUFNO1FBQ0osSUFBSSxHQUFHLEdBQUcsQ0FBQyxDQUFDO1FBQ1osSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFDLENBQUMsVUFBVSxHQUFHLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUN6RSxPQUFPLEdBQUcsQ0FBQztJQUNiLENBQUM7SUFFRCxZQUFZO1FBQ1YsT0FBTyxDQUFDLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDO0lBQ2xDLENBQUM7Q0FDRjtBQXpCRCwwQ0F5QkMifQ==